import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Agent, ContentModel, DatabaseSchemaModel, FunctionModel, GetSourcesResponse, ProcedureModel, SourceBI, SourceDWH, TableModel, ViewModel} from '../interfaces/source.interface'
import { environment } from '../../../environments/environment';
import { saveAs } from 'file-saver-es';
import { ChartResponse, FilterResponse, FolderResponse, MetricResponse, ReportChartTabReportModelDb, ReportResponse, SummarizedMetricResponse, TabResponse } from '../interfaces/source_db.interface';
import { UserSessionStorageService } from './user-sessions.service';

@Injectable({
  providedIn: 'root',
})

export class SourceService {

  private apiUrl = `${environment.apiUrl}/DataSource`;

  private apiUrlContent = `${environment.apiUrl}/Content`;

  constructor(private http: HttpClient, private sessionService: UserSessionStorageService) {
  }

  private getAuthHeaders() {
    const token = this.sessionService.getItem('access_token'); // Получаем токен из sessionStorage
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`, // Добавляем токен в заголовок
    });
  }

  getAllSources(): Observable<GetSourcesResponse> {
    return this.http.get<GetSourcesResponse>(`${this.apiUrl}/GetAll`, { headers: this.getAuthHeaders() });
  }

  getDWHSources(): Observable<SourceDWH[]> {
    return this.http.get<SourceDWH[]>(`${this.apiUrl}/GetAllDWH`, { headers: this.getAuthHeaders() });
  }

  getBISources(): Observable<SourceBI[]> {
    return this.http.get<SourceBI[]>(`${this.apiUrl}/GetAllBI`, { headers: this.getAuthHeaders() });
  }

  addDWH(addDataSourceRequest: any): Observable<number> {
    return this.http.post<number>(`${this.apiUrl}/AddDWH`, addDataSourceRequest, { headers: this.getAuthHeaders() });
  }

  addBI(addDataSourceRequest: any): Observable<number> {
    return this.http.post<number>(`${this.apiUrl}/AddBI`, addDataSourceRequest, { headers: this.getAuthHeaders() });
  }

  editDWH(editDataSourceRequest: any): Observable<number> {
    return this.http.post<number>(`${this.apiUrl}/EditDWH`, editDataSourceRequest, { headers: this.getAuthHeaders() });
  }

  editBI(editDataSourceRequest: any): Observable<number> {
    return this.http.post<number>(`${this.apiUrl}/EditBI`, editDataSourceRequest, { headers: this.getAuthHeaders() });
  }

  testConnectionDWH(testConnectionRequest: any): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`${this.apiUrl}/TestConnectionDWH`, testConnectionRequest, { headers: this.getAuthHeaders() });
  }

  testConnectionBI(testConnectionRequest: any): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`${this.apiUrl}/TestConnectionBI`, testConnectionRequest, { headers: this.getAuthHeaders() });
  }

  deleteDWH(editDataSourceRequest: any): Observable<number> {
    return this.http.post<number>(`${this.apiUrl}/DeleteDWH`, editDataSourceRequest, { headers: this.getAuthHeaders() });
  }

  deleteBI(editDataSourceRequest: any): Observable<number> {
    return this.http.post<number>(`${this.apiUrl}/DeleteBI`, editDataSourceRequest, { headers: this.getAuthHeaders() });
  }

  getFolders(dataSourceId: number): Observable<FolderResponse[]> {
    let request = {
      dataSourceId: dataSourceId
    }

    return this.http.get<FolderResponse[]>(`${this.apiUrlContent}/GetFolders`,
      {
        params: request,
        headers: this.getAuthHeaders()
      });
  }


  getReports(folderId: number): Observable<ReportResponse[]> {
    let request = {
      folderId: folderId
    }

    return this.http.get<ReportResponse[]>(`${this.apiUrlContent}/GetReportsDb`,
    {
      params: request,
      headers: this.getAuthHeaders()
    });
  }

  getHistoryReports(folderId: number, code: string): Observable<ReportResponse[]> {
    let request = {
      folderId: folderId,
      code: code
    }

    return this.http.get<ReportResponse[]>(`${this.apiUrlContent}/GetHistoryReport`,
    {
      params: request,
      headers: this.getAuthHeaders()
    });
  }

  updateReport(request: any): Observable<void> {
    return this.http.post<void>(`${this.apiUrlContent}/UpdateReport`, request,
      {
        headers: this.getAuthHeaders()
      });
  }


  exportReport(folderId: number, elementId: number): Observable<Blob> {
    let request = {
      schemaId: folderId,
      ElementId: elementId
    }

    return this.http.get(`${this.apiUrlContent}/ExportReport`,
      {
        headers: this.getAuthHeaders(),
        params: request,
        responseType: 'blob'
      });
  }

  getTabs(reportId: number): Observable<TabResponse[]> {
    let request = {
      reportId: reportId
    }

    return this.http.get<TabResponse[]>(`${this.apiUrlContent}/GetTabs`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  getFilters(tabId: number): Observable<FilterResponse[]> {
    let request = {
      tabId: tabId
    }

    return this.http.get<FilterResponse[]>(`${this.apiUrlContent}/GetFilters`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  getCharts(tabId: number): Observable<ChartResponse[]> {
    let request = {
      tabId: tabId
    }

    return this.http.get<ChartResponse[]>(`${this.apiUrlContent}/GetCharts`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }


  //DWH
  getSchemas(dataSourceId: number): Observable<DatabaseSchemaModel[]> {
    let request = {
      dataSourceId: dataSourceId
    }

    return this.http.get<DatabaseSchemaModel[]>(`${this.apiUrlContent}/GetSchemas`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  getTables(schemaId: number): Observable<TableModel[]> {
    let request = {
      schemaId: schemaId
    }

    return this.http.get<TableModel[]>(`${this.apiUrlContent}/GetTables`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  getTableById(schemaId: number, elementId: number): Observable<TableModel[]> {
    let request = {
      schemaId: schemaId,
      elementId: elementId
    }

    return this.http.get<TableModel[]>(`${this.apiUrlContent}/GetTableById`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  getHistoryTables(schemaId: number, code: string): Observable<TableModel[]> {
    let request = {
      schemaId: schemaId,
      code: code
    }

    return this.http.get<TableModel[]>(`${this.apiUrlContent}/GetHistoryTable`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  exportTables(schemaId: number, elementId: number): Observable<Blob> {
    let request = {
      schemaId: schemaId,
      ElementId: elementId
    }

    return this.http.get(`${this.apiUrlContent}/ExportTables`,
      {
        headers: this.getAuthHeaders(),
        params: request,
        responseType: 'blob'
      });
  }

  updateTable(request: any): Observable<void> {
    return this.http.post<void>(`${this.apiUrlContent}/UpdateTable`, request,
      {
        headers: this.getAuthHeaders()
      });
  }

  getProcedures(schemaId: number): Observable<ProcedureModel[]> {
    let request = {
      schemaId: schemaId
    }

    return this.http.get<ProcedureModel[]>(`${this.apiUrlContent}/GetProcedures`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  getProcedureById(schemaId: number, elementId: number): Observable<ProcedureModel[]> {
    let request = {
      schemaId: schemaId,
      elementId: elementId
    }

    return this.http.get<ProcedureModel[]>(`${this.apiUrlContent}/GetProcedureById`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  getHistoryProcedures(schemaId: number, code: string): Observable<ProcedureModel[]> {
    let request = {
      schemaId: schemaId,
      code: code
    }

    return this.http.get<ProcedureModel[]>(`${this.apiUrlContent}/GetHistoryProcedure`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  exportProcedures(schemaId: number, elementId: number): Observable<Blob> {
    let request = {
      schemaId: schemaId,
      ElementId: elementId
    }

    return this.http.get(`${this.apiUrlContent}/ExportProcedures`,
      {
        headers: this.getAuthHeaders(),
        params: request,
        responseType: 'blob'
      });
  }


  updateProcedure(request: any): Observable<void> {
    return this.http.post<void>(`${this.apiUrlContent}/UpdateProcedure`, request,
      {
        headers: this.getAuthHeaders()
      });
  }

  getViews(schemaId: number): Observable<ViewModel[]> {
    let request = {
      schemaId: schemaId
    }

    return this.http.get<ViewModel[]>(`${this.apiUrlContent}/GetViews`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  getViewById(schemaId: number, elementId: number): Observable<ViewModel[]> {
    let request = {
      schemaId: schemaId,
      elementId: elementId
    }

    return this.http.get<ViewModel[]>(`${this.apiUrlContent}/GetViewById`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  getHistoryViews(schemaId: number, code: string): Observable<ViewModel[]> {
    let request = {
      schemaId: schemaId,
      code: code
    }

    return this.http.get<ViewModel[]>(`${this.apiUrlContent}/GetHistoryView`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  exportViews(schemaId: number, elementId: number): Observable<Blob> {
    let request = {
      schemaId: schemaId,
      ElementId: elementId
    }

    return this.http.get(`${this.apiUrlContent}/ExportViews`,
      {
        headers: this.getAuthHeaders(),
        params: request,
        responseType: 'blob'
      });
  }

  updateView(request: any): Observable<void> {
    return this.http.post<void>(`${this.apiUrlContent}/UpdateView`, request,
      {
        headers: this.getAuthHeaders()
      });
  }

  getFunctions(schemaId: number): Observable<FunctionModel[]> {
    let request = {
      schemaId: schemaId
    }

    return this.http.get<FunctionModel[]>(`${this.apiUrlContent}/GetFunctions`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  getFunctionById(schemaId: number, elementId: number): Observable<FunctionModel[]> {
    let request = {
      schemaId: schemaId,
      elementId: elementId
    }

    return this.http.get<FunctionModel[]>(`${this.apiUrlContent}/GetFunctionById`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  getHistoryFunctions(schemaId: number, code: string): Observable<FunctionModel[]> {
    let request = {
      schemaId: schemaId,
      code: code
    }

    return this.http.get<FunctionModel[]>(`${this.apiUrlContent}/GetHistoryFunction`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  exportFunctions(schemaId: number, elementId: number): Observable<Blob> {
    let request = {
      schemaId: schemaId,
      ElementId: elementId
    }

    return this.http.get(`${this.apiUrlContent}/ExportFunctions`,
      {
        headers: this.getAuthHeaders(),
        params: request,
        responseType: 'blob'
      });
  }

  updateFunction(request: any): Observable<void> {
    return this.http.post<void>(`${this.apiUrlContent}/UpdateFunction`, request,
      {
        headers: this.getAuthHeaders()
      });
  }
  getSummarizedMetrics(dataSourceId: number): Observable<SummarizedMetricResponse[]> {

    let request = {
      dataSourceId: dataSourceId
    }


    return this.http.get<SummarizedMetricResponse[]>(`${this.apiUrlContent}/GetSummarizedMetrics`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }


  getMetrics(request: any): Observable<MetricResponse[]> {
    return this.http.get<MetricResponse[]>(`${this.apiUrlContent}/GetMetrics`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }
  
  getReportsByMetric(request: any): Observable<ReportChartTabReportModelDb[]> {
    return this.http.get<ReportChartTabReportModelDb[]>(`${this.apiUrlContent}/GetReportsByMetric`,
      {
        params: request,
        headers: this.getAuthHeaders()
      });
  }

  getMetricReports(request: any): Observable<ReportResponse[]> {
    return this.http.get<ReportResponse[]>(`${this.apiUrlContent}/GetReportsBySummarizedMetrics`,
      {
        params: request,
        headers: this.getAuthHeaders()
      });
  }

  getAgent(request: any): Observable<Agent[]> {
    return this.http.get<Agent[]>(`${this.apiUrl}/GetAgent`, { headers: this.getAuthHeaders(), params: request, });
  }

  addAgent(request: any): Observable<Agent> {
    console.log(request)
    return this.http.post<Agent>(`${this.apiUrl}/AddAgent`, request, { headers: this.getAuthHeaders() });
  }

  editAgent(request: any): Observable<Agent> {
    return this.http.post<Agent>(`${this.apiUrl}/EditAgent`, request, { headers: this.getAuthHeaders() });
  }

  stopAgent(request: any): Observable<Agent> {
    return this.http.post<Agent>(`${this.apiUrl}/StopAgent`, request, { headers: this.getAuthHeaders() });
  }

  deleteAgent(request: any): Observable<Agent> {
    return this.http.post<Agent>(`${this.apiUrl}/DeleteAgent`, request, { headers: this.getAuthHeaders() });
  }

  // Получение элемента по ID без указания схемы
  getElementByIdOnly(elementId: number, elementType: string): Observable<ElementByIdResponse | null> {
    let request = {
      elementId: elementId,
      elementType: elementType
    }

    return this.http.get<ElementByIdResponse | null>(`${this.apiUrlContent}/GetElementByIdOnly`,
      {
        headers: this.getAuthHeaders(),
        params: request
      });
  }

  // Получение ID источника данных DWH по schemaId
  getDataSourceIdBySchemaIdDWH(schemaId: number): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/GetDataSourceIdBySchemaIdDWH`,
      {
        headers: this.getAuthHeaders(),
        params: { schemaId: schemaId }
      });
  }

  // Получение ID источника данных BI по folderId
  getDataSourceIdByFolderIdBI(folderId: number): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/GetDataSourceIdByFolderIdBI`,
      {
        headers: this.getAuthHeaders(),
        params: { folderId: folderId }
      });
  }

}

export interface ElementByIdResponse {
  id: number;
  schemaId: number; // Для DWH - schemaId, для BI (report) - folderId
  name: string;
  description?: string;
  status?: number;
  elementType: string;
}
